import { config } from '@/config/config';
import { useDevice } from '@/hooks/use-device';
import { getDefaultMapProps } from '@/utils/map';
import { DesktopMap } from '../desktop-map/desktop-map';
import { MobileMap } from '../mobile-map/mobile-map';
import { PortInfoProvider } from '../port-info-provider';
import classes from './itinerary-map.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function ItineraryMap() {
  const defaultMapProps = getDefaultMapProps({ mapId: config.mapId });
  const { isMobile } = useDevice();

  return (
    <div className={classes.itineraryMap}>
      <PortInfoProvider>
        {isMobile ? <MobileMap mapProps={defaultMapProps} /> : <DesktopMap mapProps={defaultMapProps} />}
      </PortInfoProvider>
    </div>
  );
}
